<template>
	<li :class="className"><a class="link_tab" @click="onClick" v-html="menu"></a></li>
</template>

<script>
/**
 * 카페 서브 메뉴 아이템
 *
 * @property {string} menu			- 메뉴 이름
 * @property {string} selectedMenu	- 전역에서 선택된 메뉴
 *
 * @fires #select					- 메뉴 선택 시 이벤트 발생
 */
export default {
	props: ['menu', 'selectedMenu'],
	computed: {
		className() {
			return { on: this.menu === this.selectedMenu };
		}
	},

	methods: {
		onClick() {
			this.$emit('select', this.menu);
		}
	}
}
</script>
